import { IMembership, IOrganisationUnit, IPerson } from '@shared/integrations/taf-api/v2/models';
import type {ClubMember} from "@shared/integrations/taf-api/v1/models";

export const backdoorMember: IPerson = {
    id: '12345',
    memberNumber: 'M98765',
    socialSecurityNumber: '198505121234',
    firstName: 'Jane',
    lastName: 'Doe',
    email: 'jane.doe@example.com',
    phone: '0812345678',
    mobilePhone: '0701234567',
    autogiroStatus: 'Active',
    localDepartment: 'Stockholm',
    memberCategory: 'Full Member',
    ocrNumber: '123456789',
    protectedAddress: false,
    organizationId: 'ORG001',
    balance: 1500.5,
    originalEntryDate: '2020-01-15',
    withdrawalDate: null,
    employments: [
        {
            id: 'EMP001',
            company: {
                name: 'ABC Company',
            },
            startDate: '2021-03-01',
            endDate: null,
            employmentType: 'Full-time',
            position: 'Software Developer',
        },
    ],
    assignments: [
        {
            id: 'ASS001',
            roleName: 'Project Lead',
            startDate: '2022-01-01',
            endDate: '2022-12-31',
        },
    ],
    addresses: [
        {
            street: '123 Main St',
            zipCode: '12345',
            city: 'Stockholm',
            country: 'Sweden',
            addressType: 'Home',
        },
    ],
    previousOccupationalStatuses: [
        {
            id: 'POS001',
            name: 'Student',
            startDate: '2015-09-01',
            endDate: '2020-06-15',
        },
    ],
    occupationalStatuses: [
        {
            id: 'OS001',
            name: 'Employed',
            startDate: '2021-03-01',
            endDate: null,
        },
    ],
    upcomingOccupationalStatuses: [],
};

export const backDoorMembership: IMembership = {
    id: null,
    name: 'Gymnasieelev/Förbund Transport Förbund',
    entryDate: '2023-10-01T00:00:00+02:00',
    exitDate: null,
    active: true,
    organisationUnitId: '060c5e19-6075-e411-80c7-005056b71fb7',
};

export const backDoorUnion: IOrganisationUnit = {
    name: 'Back Door Union',
    city: 'Back Door City',
    zip: '000 00',
    phone: '000-000-0000',
    email: 'back@door.union',
    orgName: 'Back Door Union Org',
};

// Dummy data for testing - replace the actual API call with this mock data
export const mockClubMembers: ClubMember[] = [
    {
        firstName: "John",
        lastName: "Doe",
        fullName: "John Doe",
        email1: "john.doe@example.com",
        email2: "j.doe@work.com",
        mobilePhone: "+46701234567",
        telephone1: "+46812345678",
        telephone2: null,
        address1: "Storgatan 123",
        address2: "Apt 4B",
        postalCode: "11122",
        city: "Stockholm",
        country: "Sweden",
        memberFrom: "2020-01-15",
        memberTo: null,
        profession: "Software Engineer",
        professionStatus: "Active",
        memberCategory: "Professional",
        workplace: "Tech Solutions AB",
    },
    {
        firstName: "Anna",
        lastName: "Andersson",
        fullName: "Anna Andersson",
        email1: "anna.andersson@example.com",
        email2: null,
        mobilePhone: "+46709876543",
        telephone1: null,
        telephone2: null,
        address1: "Kungsgatan 456",
        address2: null,
        postalCode: "41103",
        city: "Göteborg",
        country: "Sweden",
        memberFrom: "2019-03-22",
        memberTo: null,
        profession: "Project Manager",
        professionStatus: "Active",
        memberCategory: "Senior",
        workplace: "Innovation Corp",
    },
    {
        firstName: "Erik",
        lastName: "Larsson",
        fullName: "Erik Larsson",
        email1: "erik.larsson@example.com",
        email2: "e.larsson@consulting.se",
        mobilePhone: "+46705555555",
        telephone1: "+46840987654",
        telephone2: "+46840987655",
        address1: "Drottninggatan 789",
        address2: "Suite 200",
        postalCode: "21134",
        city: "Malmö",
        country: "Sweden",
        memberFrom: "2021-06-10",
        memberTo: "2024-12-31",
        profession: "Consultant",
        professionStatus: "Active",
        memberCategory: "Associate",
        workplace: "Independent Consulting",
    },
    {
        firstName: "Maria",
        lastName: "Johansson",
        fullName: "Maria Johansson",
        email1: "maria.johansson@example.com",
        email2: null,
        mobilePhone: "+46702222222",
        telephone1: null,
        telephone2: null,
        address1: "Vasagatan 321",
        address2: null,
        postalCode: "75223",
        city: "Uppsala",
        country: "Sweden",
        memberFrom: "2018-11-05",
        memberTo: null,
        profession: "Designer",
        professionStatus: "Active",
        memberCategory: "Professional",
        workplace: "Creative Studio Ltd",
    }
];

